import { type ParsedContact, makeContact } from "../contact";
import { headerReader } from "../csv";

/** The seven columns that identify a LinkedIn Connections export (R2). */
export const LINKEDIN_HEADERS = [
	"First Name",
	"Last Name",
	"URL",
	"Email Address",
	"Company",
	"Position",
	"Connected On",
] as const;

const MONTHS = [
	"jan",
	"feb",
	"mar",
	"apr",
	"may",
	"jun",
	"jul",
	"aug",
	"sep",
	"oct",
	"nov",
	"dec",
];

/** `Connected On` is `D MMM YYYY`; anything else leaves the date unset. */
export const linkedinDate = (raw: string): string | undefined => {
	const match = raw.trim().match(/^(\d{1,2}) ([A-Za-z]{3,}) (\d{4})$/);
	if (!match) return undefined;
	const month = MONTHS.indexOf((match[2] ?? "").slice(0, 3).toLowerCase());
	const day = Number(match[1]);
	if (month === -1 || day < 1 || day > 31) return undefined;
	const pad = (value: number) => String(value).padStart(2, "0");
	return `${match[3]}-${pad(month + 1)}-${pad(day)}`;
};

export const linkedinContacts = (
	header: readonly string[],
	rows: readonly (readonly string[])[],
): ParsedContact[] => {
	const read = headerReader(header);
	return rows.map((row, index) => {
		const url = read(row, "URL");
		const email = read(row, "Email Address");
		return makeContact(index + 1, {
			name: `${read(row, "First Name")} ${read(row, "Last Name")}`,
			organisation: read(row, "Company"),
			position: read(row, "Position"),
			emails: email === "" ? [] : [email],
			date: linkedinDate(read(row, "Connected On")),
			// KTD9: the profile URL is the identity; without one the email is.
			identity: url === "" ? undefined : { system: "linkedin", value: url },
		});
	});
};
